<div class="details-form" data-testid="details-form">
    <!-- Row 1: Dealer Business Name — full width autocomplete -->
    <div class="form-row form-row--full" data-testid="form-row">
        <ntv-autocomplete
            variant="#7E7979"
            label="Dealer Business Name"
            [options]="dealerOptions()"
            [ngModel]="selectedDealer()"
            (ngModelChange)="selectedDealer.set($event)"
            [config]="{ placeholder: 'Select dealer', searchable: true, clearable: true }">
        </ntv-autocomplete>
    </div>

    <!-- Row 2: Host Business Name | Contact Number -->
    <div class="form-row form-row--2col" data-testid="form-row">
        <ntv-input
            variant="#7E7979"
            label="Host Business Name"
            placeholder="Host name"
            [ngModel]="hostBusinessName()"
            (ngModelChange)="hostBusinessName.set($event)">
        </ntv-input>
        <ntv-input
            variant="#7E7979"
            label="Contact Number"
            placeholder="Contact number"
            [ngModel]="contactNumber()"
            (ngModelChange)="contactNumber.set($event)">
        </ntv-input>
    </div>

    <!-- Row 3: Latitude | Longitude -->
    <div class="form-row form-row--2col" data-testid="form-row">
        <ntv-input
            variant="#7E7979"
            label="Latitude"
            placeholder="Latitude"
            [ngModel]="latitude()"
            (ngModelChange)="latitude.set($event)">
        </ntv-input>
        <ntv-input
            variant="#7E7979"
            label="Longitude"
            placeholder="Longitude"
            [ngModel]="longitude()"
            (ngModelChange)="longitude.set($event)">
        </ntv-input>
    </div>

    <!-- Row 4: Address | City | State -->
    <div class="form-row form-row--3col" data-testid="form-row">
        <ntv-input
            variant="#7E7979"
            label="Address"
            placeholder="Address"
            [ngModel]="address()"
            (ngModelChange)="address.set($event)">
        </ntv-input>
        <ntv-autocomplete
            variant="#7E7979"
            label="City"
            [options]="cityOptions"
            [ngModel]="selectedCity()"
            (ngModelChange)="selectedCity.set($event)"
            [config]="{ placeholder: 'City', searchable: true, clearable: true }">
        </ntv-autocomplete>
        <ntv-input
            variant="#7E7979"
            label="State"
            placeholder="State"
            [ngModel]="state()"
            (ngModelChange)="state.set($event)">
        </ntv-input>
    </div>

    <!-- Row 5: Region | Zip Code | Timezone -->
    <div class="form-row form-row--3col" data-testid="form-row">
        <ntv-input
            variant="#7E7979"
            label="Region"
            placeholder="Region"
            [ngModel]="region()"
            (ngModelChange)="region.set($event)">
        </ntv-input>
        <ntv-input
            variant="#7E7979"
            label="Zip Code"
            placeholder="Zip code"
            [ngModel]="zipCode()"
            (ngModelChange)="zipCode.set($event)">
        </ntv-input>
        <ntv-autocomplete
            variant="#7E7979"
            label="Timezone"
            [options]="timezoneOptions()"
            [ngModel]="selectedTimezone()"
            (ngModelChange)="selectedTimezone.set($event)"
            [config]="{ placeholder: 'Select timezone', searchable: true, clearable: true }">
        </ntv-autocomplete>
    </div>

    <!-- Row 6: Notes — full width -->
    <div class="form-row form-row--full" data-testid="form-row">
        <ntv-input
            variant="#7E7979"
            label="Notes"
            placeholder="Notes"
            [multiline]="true"
            [ngModel]="notes()"
            (ngModelChange)="notes.set($event)">
        </ntv-input>
    </div>
</div>
